import { FC, PropsWithChildren, useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { apiWrapper } from '@/shared/api/main';

import { ROUTES } from '@/shared/constants';

import { useLogout } from '@/features/auth';

import { setupStore } from '@/app/store/store';

/**
 * Обертка для добавление данных авторизации в запросы.
 * Auth читается из store в момент запроса, чтобы всегда использовать актуальные данные
 * @param root0 Пропсы
 * @param root0.children Дочерние элементы
 */
export const LoggedInUserApiInterceptions: FC<PropsWithChildren> = ({
  children
}) => {
  const navigate = useNavigate();
  const logout = useLogout();

  useEffect(() => {
    apiWrapper.addMonitor(response => {
      if (!response.ok && response.status === 401) {
        logout(true);
      }
      if (!response.ok && response.status === 404) {
        navigate(ROUTES.not_found);
      }
    });

    apiWrapper.addRequestTransform(request => {
      const { auth } = setupStore.getState().user;
      if (auth) {
        request.headers = { ...request.headers, ...auth };
      }
    });
  }, []);

  return children;
};
